<template>
  <div class="pager layout align-center">
    <div class="options px-2 py-1 align-center">
      <div class="arrow" @click.stop="step > 0 && step--">
        <v-icon color="primary">
          {{ icons.arrows.top }}
        </v-icon>
      </div>
      {{ step + 1 }} / {{ steps }}
      <div class="arrow" @click.stop="step < steps - 1 && step++">
        <v-icon color="primary">
          {{ icons.arrows.down }}
        </v-icon>
      </div>
    </div>
    <div v-if="current && current.data" class="content ml-2">
      {{ current.data.text }}
    </div>
  </div>
</template>

<script>
import TodoListItem from './TodoListItem';
import icons from '@/mixins/icons';
export default {
  name: 'TodoPagerView',
  mixins: [icons],
  props: {
    tasks: Array
  },

  data() {
    return {
      todos: this.tasks,
      step: 0,
      steps: this.tasks.length
    };
  },
  computed: {
    current() {
      return this.todos[this.step];
    }
  },
  watch: {
    tasks: function(o) {
      this.todos = o;
      this.steps = o.length;
    }
  }
};
</script>

<style scoped>
.options {
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  text-align: center;
  color: var(--lightish-blue);
}
.pager {
  width: 427px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
</style>
